/**
 * Aufgaben eines Bereichs (F-01): Ueberfaelliges und Heutiges oben,
 * abhakbar; neue Aufgaben landen direkt in diesem Bereich.
 */
import { useState } from 'react';

import { QuickCapture } from '@/modules/tasks/components/QuickCapture';
import { TaskRow } from '@/modules/tasks/components/TaskRow';
import { toggleTaskDone } from '@/db/repositories/tasks';
import { istUeberfaellig, nachDringlichkeit } from '@/domain/tasks/faellig';
import { today } from '@/lib/datetime';
import type { ID, Task } from '@/domain/types';

const SICHTBAR = 8;

export function BereichAufgaben({ areaId, tasks }: { areaId: ID; tasks: Task[] }) {
  const heute = today();
  const liste = nachDringlichkeit(tasks, heute);
  const ueber = liste.filter((t) => istUeberfaellig(t, heute)).length;
  const [alle, setAlle] = useState(false);

  return (
    <section aria-label="Aufgaben" className="flex flex-col gap-2 rounded-lg border border-line bg-surface px-4 py-3.5">
      <h2 className="flex items-baseline gap-2 text-sm font-semibold">
        Aufgaben ({liste.length})
        {ueber > 0 && <span className="text-[11px] font-normal text-warn">{ueber} überfällig</span>}
      </h2>
      <QuickCapture placeholder="Neue Aufgabe in diesem Bereich" status="naechste" festerBereich={areaId} />
      {liste.length === 0 && <p className="text-sm text-ink-faint">Keine offenen Aufgaben.</p>}
      <ul className="flex flex-col gap-1.5">
        {(alle ? liste : liste.slice(0, SICHTBAR)).map((t) => (
          <TaskRow key={t.id} task={t} onToggleDone={() => void toggleTaskDone(t.id)} />
        ))}
      </ul>
      {liste.length > SICHTBAR && (
        <button type="button" onClick={() => setAlle((x) => !x)} className="self-start text-[12px] text-ink-faint hover:text-ink">
          {alle ? 'Weniger anzeigen' : `Alle anzeigen (${liste.length})`}
        </button>
      )}
    </section>
  );
}
